import gql from 'graphql-tag';

export const deleteJobRole = gql`
  mutation deleteJobRole($id: String!) {
    deleteJobRole(id: $id)
  }
`;
